<template>
  <nav class="app-header">
    <router-link
      :to="{ name: 'Menu' }"
      :style="{
        visibility: admin ? 'visible' : 'hidden',
      }"
    >Menu</router-link>
    <a v-if="loggedIn" href="#" @click="logoutClicked">Logout</a>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AppHeader',
  computed: {
    ...mapGetters({
      loggedIn: 'Login/loggedIn',
      admin: 'Login/admin',
    }),
  },
  methods: {
    ...mapActions({
      logout: 'Login/logOut',
    }),
    async logoutClicked() {
      await this.logout();
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue